import { modals } from '@mantine/modals';

type ConfirmDeleteModalParams = {
    title: React.ReactNode;
    children: React.ReactNode;
    confirmLabel: string;
    onConfirm: () => void;
};

export const openConfirmDeleteModal = ({
    title,
    children,
    confirmLabel,
    onConfirm
}: ConfirmDeleteModalParams) => {
    modals.openConfirmModal({
        title: <div className="text-lg break-all">{title}</div>,
        centered: true,
        children: <div className="text-sm break-all">{children}</div>,
        labels: { confirm: confirmLabel, cancel: 'Cancel' },
        confirmProps: { color: 'red' },
        cancelProps: { variant: 'outline', color: 'gray' },
        onConfirm
    });
};
